export const navigationUrls = {
  tickets: {
    attachments: id => `/tickets/${id}/attachments`,
    attachmentsItem: (ticketId, attachId) => `/tickets/${ticketId}/attachments/${attachId}/edit`
  }
};
